import axios, { AxiosResponse } from 'axios';

import { language } from 'utils';
import { WP_HOST } from 'utils/constants';

class WPApi {
	getMenu(): Promise<AxiosResponse<unknown>> {
		return axios.get(`${WP_HOST}/wp-json/react/v2/data?lang=${language}`);
	}
}

export const WPService = new WPApi();
